import React, { useState } from "react";
import CommentForm from "./CommentForm";
import AttachmentPreview from "./AttachmentPreview";

const CommentItem = ({ comment, taskId, onUpdate, currentUserId }) => {
  const [showReplyForm, setShowReplyForm] = useState(false);
  const authToken = localStorage.getItem("auth_token");

  const handleDeleteComment = async () => {
    if (!window.confirm("Are you sure you want to delete this comment?"))
      return;

    try {
      const res = await fetch(
        `https://loopsneller.com/api/comments/${comment.id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      if (!res.ok) throw new Error("Failed to delete comment");
      onUpdate(); // refresh comments
    } catch (err) {
      console.error("Error deleting comment:", err);
    }
  };

  const handleDeleteAttachment = async (attachmentId) => {
    if (!window.confirm("Are you sure you want to delete this attachment?"))
      return;

    try {
      const res = await fetch(
        `https://loopsneller.com/api/attachments/${attachmentId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      if (!res.ok) throw new Error("Failed to delete attachment");
      onUpdate(); // refresh comments
    } catch (err) {
      console.error("Error deleting attachment:", err);
    }
  };

  return (
    <div className="mb-3">
      {/* Chat Bubble */}
      <div className="d-flex align-items-start">
        <div className="bg-light p-3 rounded shadow-sm w-100">
          <div className="d-flex justify-content-between">
            <strong>{comment.user?.name || "Unknown User"}</strong>

            {comment.user_id === currentUserId && (
              <button
                className="btn btn-sm btn-link text-danger p-0"
                onClick={handleDeleteComment}
              >
                🗑️
              </button>
            )}
          </div>

          {/* Comment Text */}
          {comment.comment && <p className="mb-1">{comment.comment}</p>}

          {/* Attachments Preview */}
          {comment.attachments && comment.attachments.length > 0 && (
            <AttachmentPreview
              attachments={comment.attachments}
              onDelete={handleDeleteAttachment}
            />
          )}

          {/* Reply Button */}
          {/* <button
            className="btn btn-sm btn-outline-secondary mt-2"
            onClick={() => setShowReplyForm(!showReplyForm)}
          >
            {showReplyForm ? "Cancel" : "Reply"}
          </button> */}
        </div>
      </div>

      {/* Reply Form */}
      {showReplyForm && (
        <div className="ms-4 mt-2">
          <CommentForm
            taskId={taskId}
            parentCommentId={comment.id}
            onSuccess={onUpdate}
          />
        </div>
      )}

      {/* Replies */}
      {comment.replies && comment.replies.length > 0 && (
        <div className="ms-4 mt-3">
          {comment.replies.map((reply) => (
            <CommentItem
              key={reply.id}
              comment={reply}
              taskId={taskId}
              onUpdate={onUpdate}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CommentItem;
